import { __awaiter, __generator } from "tslib";
import { AdiCategoryVsearchService, } from '@wix/ambassador-adi-category-vsearch-service/http';
var VSearchCategoryApiClient = /** @class */ (function () {
    function VSearchCategoryApiClient(locale) {
        if (locale === void 0) { locale = 'en-US'; }
        this.locale = locale;
        this.contentService = AdiCategoryVsearchService('https://www.wix.com/_api/adi-category-vsearch-service').ContentService()();
    }
    VSearchCategoryApiClient.prototype.suggest = function (term) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contentService.searchCategories({
                            limit: 100,
                            locale: this.locale,
                            offset: 0,
                            q: term,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.results || []];
                }
            });
        });
    };
    return VSearchCategoryApiClient;
}());
export { VSearchCategoryApiClient };
//# sourceMappingURL=VSearchCategoryApiClient.js.map